import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  class: "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mr-3",
  style: { backgroundColor: 'var(--brand-primary)' + '20' }
}
const _hoisted_6 = {
  class: "w-6 h-6",
  style: { color: 'var(--brand-primary)' },
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = { class: "px-6 py-6" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_11 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_13 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_14 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_15 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_16 = { class: "mt-1 text-gray-900 dark:text-white font-medium break-all" }
const _hoisted_17 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_18 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_19 = { class: "mb-6" }
const _hoisted_20 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_21 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_22 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_23 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_24 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_25 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_26 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_27 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_28 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_29 = { class: "mb-6" }
const _hoisted_30 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_31 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_32 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_33 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_34 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_35 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_36 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_37 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_38 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_39 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_40 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_41 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_42 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_43 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_44 = {
  class: "text-xs font-medium uppercase tracking-wide mb-2 block",
  style: {"color":"var(--brand-primary)"}
}
const _hoisted_45 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = { class: "mb-6" }
const _hoisted_49 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_50 = {
  class: "w-5 h-5 mr-2",
  style: {"color":"var(--brand-accent)"},
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_51 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_52 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_53 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_54 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_55 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_56 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_57 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_58 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_59 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_60 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_61 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_62 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_63 = { class: "flex flex-wrap gap-4" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["src", "alt"]
const _hoisted_66 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_67 = { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4" }
const _hoisted_68 = { class: "text-gray-900 dark:text-white" }
const _hoisted_69 = { class: "bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end" }
const _hoisted_70 = { class: "bg-black bg-opacity-75 text-white px-6 py-3 rounded-t-lg mb-2 w-full" }
const _hoisted_71 = { class: "flex items-center justify-between" }
const _hoisted_72 = { class: "text-sm text-gray-300" }
const _hoisted_73 = { class: "text-sm text-gray-300" }
const _hoisted_74 = ["src", "alt"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["src", "alt"]
const _hoisted_77 = { class: "bg-black bg-opacity-75 text-white px-6 py-3 rounded-t-lg mb-2 w-full" }
const _hoisted_78 = { class: "flex items-center justify-between" }
const _hoisted_79 = { class: "text-sm text-gray-300" }
const _hoisted_80 = ["src", "alt"]

import { ref } from 'vue';
import type { Tire } from '@/types/tire';


export default /*@__PURE__*/_defineComponent({
  __name: 'TireDetailsModal',
  props: {
    isOpen: { type: Boolean },
    tire: {}
  },
  emits: ["close"],
  setup(__props: any) {





const photoGalleryOpen = ref(false);
const currentPhotoIndex = ref(0);
const tirePhotoGalleryOpen = ref(false);
const currentTirePhotoIndex = ref(0);

function openPhotoGallery(index: number) {
  currentPhotoIndex.value = index;
  photoGalleryOpen.value = true;
}

function closePhotoGallery() {
  photoGalleryOpen.value = false;
  currentPhotoIndex.value = 0;
}

function previousPhoto() {
  if (currentPhotoIndex.value > 0) {
    currentPhotoIndex.value--;
  }
}

function nextPhoto() {
  currentPhotoIndex.value++;
}

function openTirePhotoGallery(index: number) {
  currentTirePhotoIndex.value = index;
  tirePhotoGalleryOpen.value = true;
}

function closeTirePhotoGallery() {
  tirePhotoGalleryOpen.value = false;
  currentTirePhotoIndex.value = 0;
}

function getPhotoUrl(path: string): string {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
  // const baseUrl = process.env.VUE_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';
  return `${baseUrl}/storage/${path}`;
}

function getStatusClass(status: string): string {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
    case 'approved':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-black/30 dark:text-gray-400';
  }
}

function getStatusDotClass(status: string): string {
  switch (status) {
    case 'pending':
      return 'bg-yellow-500 dark:bg-yellow-400';
    case 'approved':
      return 'bg-green-500 dark:bg-green-400';
    case 'rejected':
      return 'bg-red-500 dark:bg-red-400';
    default:
      return 'bg-gray-500 dark:bg-gray-400';
  }
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function formatDateOnly(dateString: string): string {
  // Parse YYYY-MM-DD without time-zone shifting by splitting manually
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.tire)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[6] || (_cache[6] = [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none"
                          }, null, -1),
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "6",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none"
                          }, null, -1),
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "2",
                            fill: "currentColor"
                          }, null, -1)
                        ])))
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Tire Registration Details ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-2 block" }, " Approval Status ", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass([getStatusClass(_ctx.tire.approval_status), "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium"])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["w-2 h-2 rounded-full mr-2", getStatusDotClass(_ctx.tire.approval_status)])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(_ctx.tire.approval_status), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", _hoisted_10, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[10] || (_cache[10] = [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ]))),
                        _cache[11] || (_cache[11] = _createTextVNode(" Customer Information "))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _cache[12] || (_cache[12] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Customer Name", -1)),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.tire.user?.first_name) + " " + _toDisplayString(_ctx.tire.user?.last_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[13] || (_cache[13] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Email", -1)),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.tire.user?.email), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Mobile Number", -1)),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.tire.user?.user_detail?.mobile || _ctx.tire.user?.userDetail?.mobile || 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h3", _hoisted_20, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[15] || (_cache[15] = [
                          _createElementVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }, null, -1),
                          _createElementVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" }, null, -1)
                        ]))),
                        _cache[16] || (_cache[16] = _createTextVNode(" Vehicle Information "))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Vehicle", -1)),
                          _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.tire.vehicle?.vehicle_make) + " " + _toDisplayString(_ctx.tire.vehicle?.vehicle_model), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Year", -1)),
                          _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.tire.vehicle?.vehicle_year), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Plate Number", -1)),
                          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.tire.vehicle?.plate_number), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("h3", _hoisted_30, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_31, _cache[20] || (_cache[20] = [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M10 2L3 7v11h14V7l-7-5zM5 9h10v7H5V9z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ]))),
                        _cache[21] || (_cache[21] = _createTextVNode(" Shop Details "))
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Shop", -1)),
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.tire.shop), 1)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Store Code", -1)),
                          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.tire.code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Invoice Number", -1)),
                          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.tire.invoice_number), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Submitted Date", -1)),
                          _createElementVNode("p", _hoisted_40, _toDisplayString(formatDate(_ctx.tire.created_at)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Date of Purchase", -1)),
                          _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.tire.purchase_date ? formatDateOnly(_ctx.tire.purchase_date) : 'N/A'), 1)
                        ])
                      ]),
                      (_ctx.tire.receipt_photos && _ctx.tire.receipt_photos.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("label", _hoisted_44, "Receipt Photos (" + _toDisplayString(_ctx.tire.receipt_photos.length) + ")", 1),
                            _createElementVNode("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tire.receipt_photos, (photo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: photo.receipt_photo_id,
                                  class: "relative group cursor-pointer",
                                  onClick: ($event: any) => (openPhotoGallery(index))
                                }, [
                                  _createElementVNode("img", {
                                    src: getPhotoUrl(photo.photo_path),
                                    alt: `Receipt photo ${index + 1}`,
                                    class: "w-full h-32 object-cover rounded-lg border-2 border-gray-200 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-200"
                                  }, null, 8, _hoisted_47),
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-200 rounded-lg flex items-center justify-center" }, [
                                    _createElementVNode("svg", {
                                      class: "w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                                      })
                                    ])
                                  ], -1))
                                ], 8, _hoisted_46))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("h3", _hoisted_49, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_50, _cache[28] || (_cache[28] = [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none"
                          }, null, -1),
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "6",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            fill: "none"
                          }, null, -1),
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "2",
                            fill: "currentColor"
                          }, null, -1)
                        ]))),
                        _cache[29] || (_cache[29] = _createTextVNode(" Tire Information "))
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _cache[30] || (_cache[30] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Brand", -1)),
                          _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.tire.brand?.brand_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Pattern", -1)),
                          _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.tire.pattern), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Size", -1)),
                          _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.tire.tire_size), 1)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "Position", -1)),
                          _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.tire.tire_position), 1)
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", {
                            class: "text-xs font-medium uppercase tracking-wide",
                            style: {"color":"var(--brand-primary)"}
                          }, "DOT", -1)),
                          _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.tire.dot), 1)
                        ])
                      ]),
                      (_ctx.tire.tire_photos && _ctx.tire.tire_photos.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _cache[36] || (_cache[36] = _createElementVNode("label", {
                              class: "text-xs font-medium uppercase tracking-wide mb-2 block",
                              style: {"color":"var(--brand-primary)"}
                            }, "Tire Photo", -1)),
                            _createElementVNode("div", _hoisted_63, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tire.tire_photos, (photo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: photo.tire_photo_id,
                                  class: "relative group cursor-pointer",
                                  onClick: ($event: any) => (openTirePhotoGallery(index))
                                }, [
                                  _createElementVNode("img", {
                                    src: getPhotoUrl(photo.photo_path),
                                    alt: `Tire photo ${index + 1}`,
                                    class: "h-32 w-auto object-cover rounded-lg border-2 border-gray-200 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-200"
                                  }, null, 8, _hoisted_65),
                                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-200 rounded-lg flex items-center justify-center" }, [
                                    _createElementVNode("svg", {
                                      class: "w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                                      })
                                    ])
                                  ], -1))
                                ], 8, _hoisted_64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.tire.rejection_reason)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }, [
                            _createElementVNode("svg", {
                              class: "w-5 h-5 mr-2 text-red-500",
                              fill: "currentColor",
                              viewBox: "0 0 20 20"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                "clip-rule": "evenodd"
                              })
                            ]),
                            _createTextVNode(" Rejection Reason ")
                          ], -1)),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.tire.rejection_reason), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                    }, " Close ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (photoGalleryOpen.value && _ctx.tire)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[60] bg-black bg-opacity-95 flex items-center justify-center p-4",
              onClick: closePhotoGallery
            }, [
              _createElementVNode("button", {
                onClick: closePhotoGallery,
                class: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
              }, _cache[39] || (_cache[39] = [
                _createElementVNode("svg", {
                  class: "h-8 w-8",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])),
              (currentPhotoIndex.value > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _withModifiers(previousPhoto, ["stop"]),
                    class: "absolute left-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                  }, _cache[40] || (_cache[40] = [
                    _createElementVNode("svg", {
                      class: "h-12 w-12",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M15 19l-7-7 7-7"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "max-w-7xl max-h-full flex flex-col items-center",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", null, [
                      _cache[41] || (_cache[41] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Receipt Photo", -1)),
                      _createElementVNode("p", _hoisted_72, _toDisplayString(_ctx.tire.pattern) + " - " + _toDisplayString(_ctx.tire.tire_size), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, " Photo " + _toDisplayString(currentPhotoIndex.value + 1) + " of " + _toDisplayString(_ctx.tire.receipt_photos?.length || 0), 1)
                  ])
                ]),
                (_ctx.tire.receipt_photos && _ctx.tire.receipt_photos[currentPhotoIndex.value])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: getPhotoUrl(_ctx.tire.receipt_photos[currentPhotoIndex.value].photo_path),
                      alt: `Receipt Photo ${currentPhotoIndex.value + 1}`,
                      class: "max-w-full max-h-[calc(100vh-200px)] object-contain rounded-lg shadow-2xl"
                    }, null, 8, _hoisted_74))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.tire.receipt_photos && currentPhotoIndex.value < _ctx.tire.receipt_photos.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _withModifiers(nextPhoto, ["stop"]),
                    class: "absolute right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                  }, _cache[42] || (_cache[42] = [
                    _createElementVNode("svg", {
                      class: "h-12 w-12",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M9 5l7 7-7 7"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (_ctx.tire.receipt_photos && _ctx.tire.receipt_photos.length > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-black bg-opacity-75 p-3 rounded-lg max-w-full overflow-x-auto",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tire.receipt_photos, (photo, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: photo.receipt_photo_id,
                        onClick: ($event: any) => (currentPhotoIndex.value = index),
                        class: _normalizeClass(["flex-shrink-0 w-16 h-16 rounded-md overflow-hidden border-2 transition-all duration-200", currentPhotoIndex.value === index ? 'border-white scale-110' : 'border-gray-600 opacity-60 hover:opacity-100'])
                      }, [
                        _createElementVNode("img", {
                          src: getPhotoUrl(photo.photo_path),
                          alt: `Thumbnail ${index + 1}`,
                          class: "w-full h-full object-cover"
                        }, null, 8, _hoisted_76)
                      ], 10, _hoisted_75))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (tirePhotoGalleryOpen.value && _ctx.tire && _ctx.tire.tire_photos && _ctx.tire.tire_photos.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[60] bg-black bg-opacity-95 flex items-center justify-center p-4",
              onClick: closeTirePhotoGallery
            }, [
              _createElementVNode("button", {
                onClick: closeTirePhotoGallery,
                class: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
              }, _cache[43] || (_cache[43] = [
                _createElementVNode("svg", {
                  class: "h-8 w-8",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "max-w-7xl max-h-full flex flex-col items-center",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", null, [
                      _cache[44] || (_cache[44] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Tire Photo", -1)),
                      _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.tire.pattern) + " - " + _toDisplayString(_ctx.tire.tire_size), 1)
                    ])
                  ])
                ]),
                _createElementVNode("img", {
                  src: getPhotoUrl(_ctx.tire.tire_photos[currentTirePhotoIndex.value].photo_path),
                  alt: `Tire Photo ${currentTirePhotoIndex.value + 1}`,
                  class: "max-w-full max-h-[calc(100vh-200px)] object-contain rounded-lg shadow-2xl"
                }, null, 8, _hoisted_80)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})